module.exports = __webpack_public_path__ + "static/media/notification-closs-icon.dbda1c17.svg";